import styled, { keyframes } from 'styled-components'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const formatRupiah = (value) => `Rp${newFormatThousandSeparator(value)}`

const expandIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const Container = styled.div`
  padding: 12px 20px;
  background-color: #fafafa;
  animation: ${expandIn} 0.28s ease-out;
`

const SectionDivider = ({ label, color }) => (
	<div className="d-flex align-items-center gap-2 mb-2">
		<span
			className="fw-bold text-uppercase"
			style={{ color, fontSize: '13px', letterSpacing: '0.4px', whiteSpace: 'nowrap' }}
		>
			{label}
		</span>
		<span
			className="flex-grow-1"
			style={{ borderTop: `1px solid ${color}33` }}
		/>
	</div>
)

const BreakdownRow = ({ name, value, pct, color }) => (
	<div
		className="d-flex justify-content-between align-items-center py-1"
		style={{ fontSize: '15px', borderBottom: '1px solid #F1F1F1' }}
	>
		<span className="d-flex align-items-center gap-2 text-truncate">
			<span
				style={{
					width: '7px',
					height: '7px',
					borderRadius: '50%',
					backgroundColor: color,
					flexShrink: 0,
				}}
			/>
			<span className="text-truncate">{name}</span>
		</span>
		<span className="text-nowrap ms-2">
			{formatRupiah(value)}
			<span className="text-muted"> ({pct}%)</span>
		</span>
	</div>
)

const PeriodBreakdownRow = ({ data }) => {
	const income = data?.breakdown?.income || []
	const expense = data?.breakdown?.expense || []
	const totalIncome = income.reduce((sum, item) => sum + item.value, 0)
	const totalExpense = expense.reduce((sum, item) => sum + item.value, 0)
	const isEmpty = !income.length && !expense.length

	if (isEmpty) {
		return (
			<Container className="text-muted" style={{ fontSize: '15px' }}>
				Tidak ada transaksi pada periode ini.
			</Container>
		)
	}

	return (
		<Container>
			{income.length > 0 && (
				<div className="mb-2">
					<SectionDivider label="Pemasukan" color="#039855" />
					{income.map(({ name, value }) => {
						const pct = totalIncome > 0 ? Math.round((value / totalIncome) * 100) : 0
						return (
							<BreakdownRow
								key={`income-${name}`}
								name={name}
								value={value}
								pct={pct}
								color="#039855"
							/>
						)
					})}
				</div>
			)}

			{expense.length > 0 && (
				<div>
					<SectionDivider label="Pengeluaran" color="#D92D20" />
					{expense.map(({ name, value }) => {
						const pct = totalExpense > 0 ? Math.round((value / totalExpense) * 100) : 0
						return (
							<BreakdownRow
								key={`expense-${name}`}
								name={name}
								value={value}
								pct={pct}
								color="#D92D20"
							/>
						)
					})}
				</div>
			)}
		</Container>
	)
}

export default PeriodBreakdownRow
